const HASH_ROUTING_HOSTS = new Set(['mail.qixit.com', 'stmail.qixit.com']);

export function usesHashRouting(): boolean {
  if (typeof window === 'undefined') return false;
  return HASH_ROUTING_HOSTS.has(window.location.hostname.toLowerCase());
}

export function isAuthEntryRoute(): boolean {
  if (typeof window === 'undefined') return false;

  const path = window.location.pathname.toLowerCase();
  const hash = (window.location.hash || '').toLowerCase();
  const authPaths = ['/login', '/register', '/verify-email', '/reset-password'];

  return authPaths.some((authPath) => path.includes(authPath) || hash.includes(authPath));
}

export function getLoginPath(): string {
  return usesHashRouting() ? '/#/login' : '/login';
}

export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  window.location.replace(getLoginPath());
}

export function isPublicAuthRequest(url?: string): boolean {
  if (!url) return false;
  const normalized = url.toLowerCase();
  return (
    normalized.includes('/api/auth/login')
    || normalized.includes('/api/auth/refresh')
    || normalized.includes('/api/auth/logout')
    || normalized.includes('/api/auth/verify-ip')
    || normalized.includes('/api/auth/verifyip')
  );
}
